import { RpcForwardReportData, RpcForwardResponse } from './rpc-forward-model';

/**
 * Rpc forward down handler interface.
 */
export interface RpcForwardDownHandler<T> {
    handler(data: RpcForwardReportData): Promise<RpcForwardResponse<T>>;
}
